import { supabase } from './supabase';
import { getAuthUser } from './tenant';

// Log an app-level event (login/logout/etc.) to audit_logs. Non-blocking.
export async function logAudit(action, { entity_type = null, entity_id = null, metadata = null, userId = null } = {}) {
  try {
    let uid = userId;
    if (!uid) {
      const user = await getAuthUser();
      uid = user?.id;
    }
    if (!uid) return;
    await supabase.from('audit_logs').insert({
      user_id: uid,
      action,
      entity_type,
      entity_id,
      metadata,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    });
  } catch (_) {
    // never block the user flow on logging
  }
}
